import styled, {css} from 'styled-components'

export const StyledLabel = styled.label`
    ${({theme: {palette, truncateText, typography}}) => css`
        display: block;
        color: ${palette.neutral['700']};
        font-weight: 400;
        text-align: start;
        ${typography.textMd}
        ${truncateText}
    `}
`
